module.exports = __webpack_public_path__ + "img/payment_gateways.e96dfcd1.png";